import { apiGet, apiPost, getObject } from "../../utils"
import axios from "axios"
import { API_URL } from "../../constants"

export function addRevenueAdminAPI(data) {
    return apiPost('/api/addRevenueAdmin', data)
}

export function getReportRequestAdminAPI(data) {
    return apiGet('/api/getReportRequestAdmin', data)
}

export function confirmReportDeliveryAdminAPI(data) {
    return apiPost('/api/confirmReportDeliveryAdmin', data)
}

export function closeTicketAdminAPI(data) {
    return apiPost('/api/closeTicketAdmin', data)
}

export function getUserListAdminAPI(filters) {
    const { search = '' } = filters || {}
    return apiGet(`/api/getUserListAdmin?search=${search}`)
}

export function getUserDetailsByIdForAdminAPI(data) {
    return apiGet(`/api/getUserDetailsByIdForAdmin?user_id=${data || 9}`)
}

export function revokeUnrevokeUserForAdminAPI(data) {
    return apiPost('/api/revokeUnrevokeUserForAdmin', data)
}

export function getTicketListForAdminAPI(data) {
    const { sort = '', search = '' } = data || {}
    return apiGet(`/api/getTicketListForAdmin?sort=${sort}&search=${search}`)
}

export function getTicketByIdAPI(ticket_id) {
    return apiGet(`/api/getTicketById?ticket_id=${ticket_id}`)
}

export function sendInviteAPI(data) {
    return apiPost(`/api/sendInvite`, data)
}

export function replyTicketAPI(data) {
    return apiPost(`/api/replyTicket`, data)
}

export function editTicketReplyAdminAPI(data) {
    return apiPost(`/api/editTicketReplyAdmin`, data)
}

export function deleteTicketReplyAdminAPI(data) {
    return apiPost(`/api/deleteTicketReplyAdmin`, data)
}

export function getWithdrawRequestAdminAPI(data) {
    return apiGet(`/api/getWithdrawRequestAdmin`, data)
}

export function getSentInvitationsAdminAPI(data) {
    const { limit = 30, offset = 0 } = data || {}
    return apiGet(`/api/getSentInvitationsAdmin?limit=${limit}&offset=${offset}`, data)
}

export function sentMoneyByAdminAPI(data) {
    return apiPost(`/api/sentMoneyByAdmin`, data)
}

export function rejectPayoutByAdminAPI(data) {
    return apiPost('/api/rejectPayoutByAdmin', data)
}

export function getAllArtistNamesAdminAPI(filters) {
    const { limit = 10, offset = 0, search = '' } = filters || {}
    return apiGet(`/api/getAllArtistNamesAdmin?limit=${limit}&offset=${offset}&search=${search}`, filters)
}

export function countMeterAdminAPI(data) {
    return apiGet(`/api/countMeterAdmin`, data)
}

export function checkAwayStatusAPI(data) {
    return apiGet(`/api/checkAwayStatus`, data)
}

export function changeAwayStatusAdminAPI(data) {
    return apiPost(`/api/changeAwayStatusAdmin`, data)
}

export function updateAlbumArtworkAdminAPI(data) {
    return apiPost(`/api/updateAlbumArtworkAdmin`, data)
}

export function sendSpecificNotificationsAdminAPI(data) {
    return apiPost(`/api/sendSpecificNotificationsAdmin`, data)
}

export function deleteFileFromServerAPI(data) {
    return apiPost(`/api/deleteFileFromServer`, data)
}

export function uploadAPI(data) {
    const data1 = new FormData();
    data1.append("image", data)
    return apiPost(`/api/upload`, data1)
}

export function videoUploadAPI(data) {
    const data1 = new FormData();
    data1.append("image", data)
    return apiPost(`/api/videoUpload`, data1)
}

export function getWithdrawHistoryAdminAPI(data) {
    const { limit = 30, offset = 0 } = data || {}
    return apiGet(`/api/getWithdrawHistoryAdmin?limit=${limit}&offset=${offset}`, data)
}

export function exportPayoutHistoryAdminAPI(period) {
    const auth = getObject("auth") || {}
    return axios.get(`${API_URL}/api/exportPayoutHistoryAdmin?period=${period}`, {
        headers: { Authorization: auth },
        responseType: 'blob'
    })
}

export function promoImageUploadAdminAPI(data) {
    const data1 = new FormData();
    data1.append("image", data)
    return apiPost(`/api/promoImageUploadAdmin`, data1)
}

export function createPromotionsAdminAPI(data) {
    return apiPost(`/api/createPromotionsAdmin`, data)
}

export function getOnlineUsersAdminAPI() {
    return apiGet('/api/getOnlineUsersAdmin')
}

export function verifyUserDetailsPasswordAPI(data) {
    return apiPost('/api/verifyUserDetailsPassword', data)
}

export function adminHeartbeatAPI() {
    return apiPost('/api/adminHeartbeat', {})
}

export function getAdminStatusesAPI() {
    return apiGet('/api/getAdminStatuses')
}

export function getSubAdminStatusesAdminAPI() {
    return apiGet('/api/getSubAdminStatusesAdmin')
}

export function getTrackerTicketsAdminAPI(filters) {
    const params = new URLSearchParams()
    if (filters?.status) params.append('status', filters.status)
    if (filters?.priority) params.append('priority', filters.priority)
    if (filters?.request_type) params.append('request_type', filters.request_type)
    if (filters?.assigned_to) params.append('assigned_to', filters.assigned_to)
    if (filters?.search) params.append('search', filters.search)
    if (filters?.sort_by) params.append('sort_by', filters.sort_by)
    return apiGet(`/api/getTrackerTicketsAdmin?${params.toString()}`)
}

export function createTrackerTicketAdminAPI(data) {
    return apiPost('/api/createTrackerTicketAdmin', data)
}

export function updateTrackerTicketStatusAdminAPI(data) {
    return apiPost('/api/updateTrackerTicketStatusAdmin', data)
}

export function getTrackerActivityLogAdminAPI(tracker_id) {
    return apiGet(`/api/getTrackerActivityLogAdmin?tracker_id=${tracker_id}`)
}

export function getTrackerCommentsAdminAPI(tracker_id) {
    return apiGet(`/api/getTrackerCommentsAdmin?tracker_id=${tracker_id}`)
}

export function addTrackerCommentAdminAPI(data) {
    return apiPost('/api/addTrackerCommentAdmin', data)
}

export function updateTrackerTicketDetailsAdminAPI(data) {
    return apiPost('/api/updateTrackerTicketDetailsAdmin', data)
}

export function getSubAdminTrackerStatsAdminAPI() {
    return apiGet('/api/getSubAdminTrackerStatsAdmin')
}

export function getTrackerTicketByIdAdminAPI(tracker_id) {
    return apiGet(`/api/getTrackerTicketByIdAdmin?tracker_id=${tracker_id}`)
}

export function updateUserDetailsAdminAPI(data) {
    return apiPost('/api/updateUserDetailsAdmin', data)
}

export function getAdminNotificationsAPI() {
    return apiGet('/api/getAdminNotifications')
}

export function checkAdminNotificationBellAPI() {
    return apiGet('/api/checkAdminNotificationBell')
}

export function markAdminNotificationsReadAPI() {
    return apiPost('/api/markAdminNotificationsRead', {})
}

export function getNotificationTemplatesAdminAPI() {
    return apiGet('/api/getNotificationTemplatesAdmin')
}